import { NBACategory, NextBestAction, PegaCDHContainerOffer } from '@ap/interface-pega';

/**
 * @ngdoc service
 * @name ResultPageMapper
 */
export class ResultPageMapper {
    public static mapRankedResultsToNextBestAction(rankedResults: PegaCDHContainerOffer[]): NextBestAction {
        if (rankedResults == null || rankedResults[0]?.VB_ContentText == null) {
            return null;
        }

        const containerOffer = rankedResults[0];

        return {
            ...(containerOffer.Name && {
                name: containerOffer.Name
            }),
            text: `${containerOffer.VB_ContentText}`,
            ...(containerOffer.ContentURL && {
                link: containerOffer.ContentURL
            }),
            ...(containerOffer.ClickThroughURL && {
                notifyLink: containerOffer.ClickThroughURL
            }),
            ...(containerOffer.VB_Button_LinkLabel && {
                linkText: containerOffer.VB_Button_LinkLabel
            }),
            ...(containerOffer.InteractionID && {
                interactionID: containerOffer.InteractionID
            }),
            ...(containerOffer.Category && {
                category: ResultPageMapper.mapStringCategoryToNBACategory(containerOffer.Category)
            }),
            ...(containerOffer.Group && {
                group: containerOffer.Group
            }),
            ...(containerOffer.Issue && {
                issue: containerOffer.Issue
            }),
            ...(containerOffer.Identifier && {
                identifier: containerOffer.Identifier
            }),
            title: containerOffer.VB_Title,
            ...(containerOffer.Rank && {
                rank: containerOffer.Rank
            })
        };
    }

    private static mapStringCategoryToNBACategory(category: string): NBACategory {
        if (category === 'Maintenance') {
            return NBACategory.MAINTENANCE;
        }
        return NBACategory.OTHER;
    }
}
